const initObfuscateLink = () => {
  const obfuscateLinkElem = document.querySelector('.ob-l') as HTMLInputElement;

  if (null === obfuscateLinkElem) {
    return;
  }

  obfuscateLinkElem.addEventListener("click", function () {
    let url = this.name;
    url = url.replace('yatta-', 'http://');
    url = url.replace('yattas-', 'https://');
    url = url.replace('yattaw-', 'http://www.');
    url = url.replace('yattasw-', 'https://www.');
    url = url.replace(/---/g, '.');

    window.open(url, '_self');
  });
};

export default initObfuscateLink;

